<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar />
      </flex-col>
      <flex-col :span="3" md4 sm8 v-for="(emoji, index)  in emojis" :key="index" :class="['text-center']">
        <container :class="['p-2', 'cursor-pointer']" :title="`${$lang.clickToCopy} '${emoji}'`" @click.native="copyToClipboard(emoji)">
          <emoji :name="emoji" />
          <divider :class="['my-3']" />
          <code v-html="emoji" :class="['text-xs', 'block', 'truncate']" />
        </container>
      </flex-col>
      <snackbar v-model="snackbar" :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness">{{ $lang.copiedToClipboard(copiedValue) }}</snackbar>
    </flex>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageEmoji',
  mixins: [
    methods
  ],
  data () {
    return {
      emojis: [],
      snackbar: false,
      copiedValue: null
    }
  },
  mounted () {
    this.getExternalData('emoji.json', 'emojis')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ui/emoji.vue